module.exports = __webpack_public_path__ + "img/home_61.62bae758.svg";